import { loadStripe } from "@stripe/stripe-js";
import { stripePublicKey } from "env";

export const stripePromise = loadStripe(stripePublicKey);
